import ContributorLogin from "@/components/login/ContributorLogin";
import MicrosoftLogin from "@/components/login/MicrosoftLogin";
import { Button } from "@/components/ui/button";
import { useState } from "react";

const Login = () => {
	const [loginType, setLoginType] = useState<"microsoft" | "contributor">(
		"microsoft"
	);

	return (
		<div className="bg-slate-100 h-screen flex flex-col items-center justify-center">
			{loginType === "microsoft" ? <MicrosoftLogin /> : <ContributorLogin />}
			<div className="mt-4">
				<Button
					variant="outline"
					type="button"
					onClick={() =>
						setLoginType((prev) =>
							prev === "microsoft" ? "contributor" : "microsoft"
						)
					}
				>
					{loginType === "microsoft" ? "Login as Contributor" : "Login as Staff"}
				</Button>
			</div>
		</div>
	);
};

export default Login;
